module.exports = __webpack_public_path__ + "static/media/Opened.72683e6e.svg";